module.exports = __webpack_public_path__ + "img/进入中.fa293bac.gif";